import { AxiosInstance } from 'axios';
import React, { createContext, FC, useContext } from 'react';
import FreightRepository from '@common/repositories/freight.context';
import { useAuth } from '@unbooking/ui-auth';

const getRepositories = (axios: AxiosInstance) => ({
  freightRepository: new FreightRepository(axios),
});

const RepositoryContext = createContext({} as ReturnType<typeof getRepositories>);

interface IRepositoryProvider {
  children?: React.ReactNode;
}

const RepositoryProvider: FC<IRepositoryProvider> = ({ children }) => {
  const { axios } = useAuth();

  return (
    <RepositoryContext.Provider value={getRepositories(axios)}>
      {children}
    </RepositoryContext.Provider>
  );
};

const useRepository = () => useContext(RepositoryContext);

export { RepositoryProvider, useRepository };
